<template>
  <video class="preview" muted autoplay playsinline controls>
    <source :src="post.videoSrc" type="video/mp4">
    <source :src="post.videoSrc" type="video/ogg">
    <img :src="post.previewPic" alt="" />
  </video>
</template>

<script>
export default {
  props: ['post']
}
</script>

<style lang="scss">
video.preview {
  width: 100%;
  max-height: 70vh;
}
</style>
